import React, { useEffect, useLayoutEffect, useState, useRef, useCallback } from "react";
import { useHistory, useLocation } from "react-router-dom";
import NavButton from "../homepage/header-banner/TopNavButton";
import Footer from "../homepage/footer/Footer";
import "bootstrap/dist/css/bootstrap.min.css";
import "../Style/typo.css";
import "../container/Sidebar/sidebar.css";
import { Container, Row, Col, Offcanvas } from "react-bootstrap";
import { AiOutlineDown, AiOutlineMenu } from "react-icons/ai";

import { HelpDeskBanner, HelpDeskBody } from "./helpdesk-main";
import { ChatbotBanner, ChatbotBody } from "./chatbot";
import { AICallKOBanner, AICallKOBody } from "./ai-call-ko";
import { VideoBanner, VideoBody } from "./video-conference";
import CloudAiCall from "./fetchHanbiroCloudPage/cloud-ai-call";
import CloudChatbot from "./fetchHanbiroCloudPage/cloud-chatbot";
import CloudHelpdesk from "./fetchHanbiroCloudPage/cloud-helpdesk";
import CloudVideoConference from "./fetchHanbiroCloudPage/cloud-video-conference";
import { TalkContent } from "./hanbiro-talk";

const PAGES = [
    // {
    //     id: "chatbot",
    //     label: "Help 챗봇",
    //     Banner: ChatbotBanner,
    //     Body: ChatbotBody,
    //     subMenus: [
    //         { id: "intro", label: "도입 효과" },
    //         { id: "usage", label: "사용 방법" },
    //         { id: "qa", label: "질의응답 확인" },
    //         { id: "faq", label: "자주하는 질문" },
    //     ],
    // },
    // {
    //     id: "helpdesk",
    //     label: "Helpdesk",
    //     Banner: HelpDeskBanner,
    //     Body: HelpDeskBody,
    //     subMenus: [
    //         { id: "ai-phone", label: "AI 전화" },
    //         { id: "ticket", label: "티켓" },
    //         { id: "livechat", label: "라이브챗" },
    //         { id: "customer", label: "고객관리" },
    //         { id: "knowledge", label: "지식창고" },
    //     ],
    // },
    // {
    //     id: "aicall",
    //     label: "AI 전화",
    //     Banner: AICallKOBanner,
    //     Body: AICallKOBody,
    //     subMenus: [
    //         { id: "advantage", label: "AI 전화 장점" },
    //         { id: "process", label: "AI 호출 프로세스" },
    //         { id: "features", label: "AI 전화 기능" },
    //         { id: "install", label: "AI 전화 설치 가이드" },
    //     ],
    // },
    // {
    //     id: "video-conference",
    //     label: "AI 전화 기능",
    //     Banner: VideoBanner,
    //     Body: VideoBody,
    //     subMenus: [
    //         { id: "video-ai-feature", label: "화상회의 주요 기능" },
    //         { id: "video-key-feature", label: "화상회의 특장점" },
    //     ],
    // },
    {
        id: "chatbot",
        label: "Help 챗봇",
        Banner: () => null,
        Body: () => <CloudChatbot embedMode={true} />,
        subMenus: [
            { id: "cb-intro", label: "도입 효과" },
            { id: "cb-usage", label: "사용 방법" },
            { id: "cb-qa", label: "질의응답 확인" },
            { id: "cb-faq", label: "자주하는 질문" },
        ],
    },
    {
        id: "helpdesk",
        label: "Helpdesk",
        Banner: () => null,
        Body: () => <CloudHelpdesk embedMode={true} />,
        subMenus: [
            { id: "hd-ai-phone", label: "AI 전화" },
            { id: "hd-ticket", label: "티켓" },
            { id: "hd-livechat", label: "라이브챗" },
            { id: "hd-customer", label: "고객관리" },
            { id: "hd-knowledge", label: "지식창고" },
        ],
    },
    {
        id: "aicall",
        label: "AI 전화",
        Banner: () => null,
        Body: () => <CloudAiCall embedMode={true} />,
        subMenus: [
            { id: "ac-advantage", label: "AI 전화 장점" },
            { id: "ac-process", label: "AI 호출 프로세스" },
            { id: "ac-features", label: "AI 전화 기능" },
            { id: "ac-install", label: "AI 전화 설치 가이드" },
        ],
    },
    {
        id: "video-conference",
        label: "AI 전화 기능",
        Banner: () => null,
        // Body & subMenus handled dynamically in GroupwareClone
        subMenus: [],
    },
];

// 서브메뉴 동적 정의: tab별 다른 레이블
const VIDEO_CONF_SUBMENUS = {
    hanbirotalk: [
        { id: "video-messenger-feature", label: "메신저 특장점" },
        { id: "video-messenger-main-feature", label: "메신저 주요기능" },
    ],
    videoconference: [
        { id: "video-key-feature", label: "화상회의 특장점" },
        { id: "video-ai-feature", label: "화상회의 주요 기능" },
    ],
};

function DemoSidebar({ pages, activePage, activeSub, onSelectPage, onScrollTo, onCloseOffcanvas }) {
    const [openMenus, setOpenMenus] = useState(() => pages.reduce((acc, p) => ({ ...acc, [p.id]: p.id === pages[0].id }), {}));

    const toggleMenu = (pageId) => {
        setOpenMenus((prev) => ({
            ...prev,
            [pageId]: activePage === pageId ? !prev[pageId] : true,
        }));
        if (activePage !== pageId) {
            onSelectPage(pageId);
            // Do NOT close sidebar when switching pages
        }
    };

    return (
        <div className="groupware-sidebar" style={styles.sidebar}>
            {pages.map((page) => {
                const isActive = activePage === page.id;
                const isOpen = openMenus[page.id] !== undefined ? openMenus[page.id] : isActive;

                return (
                    <div key={page.id} style={styles.sidebarItem}>
                        {/* Parent menu */}
                        <div
                            style={{
                                ...styles.sidebarParent,
                                color: isActive ? "#7061ff" : "#333",
                                background: isActive ? "#f8f7ff" : "transparent",
                            }}
                            onClick={() => toggleMenu(page.id)}
                        >
                            <span style={styles.sidebarParentLabel}>{page.label}</span>
                            <span
                                style={{
                                    ...styles.sidebarChevron,
                                    transform: isOpen ? "rotate(180deg)" : "rotate(0deg)",
                                    color: isActive ? "#7061ff" : "#999",
                                }}
                            >
                                <AiOutlineDown />
                            </span>
                        </div>

                        {/* Sub menus */}
                        {isOpen && page.subMenus.length > 0 && (
                            <ul style={styles.sidebarSubList}>
                                {page.subMenus.map((sub) => {
                                    const isSubActive = activeSub === sub.id;
                                    return (
                                        <li
                                            key={sub.id}
                                            style={{
                                                ...styles.sidebarSubItem,
                                                color: isSubActive ? "#7061ff" : "#666",
                                                fontWeight: isSubActive ? "bold" : "normal",
                                            }}
                                            onClick={() => {
                                                const isNewPage = !isActive;
                                                if (isNewPage) {
                                                    onSelectPage(page.id, sub.id);
                                                } else {
                                                    onScrollTo(sub.id);
                                                }
                                                // Do NOT close sidebar when switching sub-menus
                                            }}
                                        >
                                            <span style={styles.sidebarArrow}>›</span>
                                            <span style={styles.sidebarSubLabel}>{sub.label}</span>
                                        </li>
                                    );
                                })}
                            </ul>
                        )}
                    </div>
                );
            })}
        </div>
    );
}

// Map page id -> route path
const PAGE_ROUTES = {
    chatbot: "/chatbot",
    helpdesk: "/helpdesk",
    aicall: "/ai-call",
    "video-conference": "/video-conference",
};

// Map route path -> page id
const PATH_TO_PAGE = {
    "/chatbot": "chatbot",
    "/helpdesk": "helpdesk",
    "/ai-call": "aicall",
    "/video-conference": "video-conference",
    "/hanbiro-talk": "video-conference",
};

function GroupwareClone() {
    const history = useHistory();
    const location = useLocation();

    // Derive activePage from URL — no remount needed when URL changes
    const pageFromUrl = PATH_TO_PAGE[location.pathname] || PAGES[0].id;
    const [activePage, setActivePage] = useState(pageFromUrl);
    const [activeSub, setActiveSub] = useState(null);
    const [showOffcanvas, setShowOffcanvas] = useState(false);
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);
    const [talkActiveTab, setTalkActiveTab] = useState(location.pathname === "/hanbiro-talk" ? "hanbirotalk" : "videoconference"); // track active tab inside TalkContent
    const pendingScroll = useRef(null);
    const isManualScroll = useRef(false);
    const sidebarRef = useRef(null);

    // Sync activePage and talkActiveTab when URL changes (e.g. browser back/forward)
    useEffect(() => {
        const pageId = PATH_TO_PAGE[location.pathname];
        if (pageId && pageId !== activePage) {
            setActivePage(pageId);
        }
        if (location.pathname === "/hanbiro-talk") {
            setTalkActiveTab("hanbirotalk");
        } else if (location.pathname === "/video-conference") {
            setTalkActiveTab("videoconference");
        }
    }, [location.pathname, activePage]);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (showOffcanvas && sidebarRef.current && !sidebarRef.current.contains(event.target)) {
                setShowOffcanvas(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, [showOffcanvas]);

    useEffect(() => {
        const handleResize = () => setWindowWidth(window.innerWidth);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const currentPage = PAGES.find((p) => p.id === activePage) || PAGES[0];

    // SubMenus động cho video-conference dựa theo tab đang active
    const currentSubMenus = currentPage.id === "video-conference"
        ? VIDEO_CONF_SUBMENUS[talkActiveTab] || []
        : currentPage.subMenus;

    // Stable callback — không đổi reference qua mọi render
    const handleTalkTabChange = useCallback((tab) => {
        setTalkActiveTab(tab);
        setActiveSub(null);
        if (tab === "hanbirotalk") {
            history.replace("/hanbiro-talk");
        } else {
            history.replace("/video-conference");
        }
    }, [history]);

    useEffect(() => {
        if ("scrollRestoration" in window.history) {
            window.history.scrollRestoration = "manual";
        }
        document.title = "Groupware - Hanbiro Cloud";
        window.scrollTo(0, 0);
    }, []);

    useLayoutEffect(() => {
        if (pendingScroll.current) {
            const el = document.getElementById(pendingScroll.current) || document.querySelector('.' + pendingScroll.current);
            if (el) {
                const y = el.getBoundingClientRect().top + window.pageYOffset - 90;
                window.scrollTo({ top: y, behavior: "auto" });
            }
            pendingScroll.current = null;
            document.body.style.overflow = "";
        }
    }, [activePage]);

    useEffect(() => {
        const subIds = currentSubMenus.map((s) => s.id);
        if (subIds.length === 0) return;

        const handleScroll = () => {
            if (isManualScroll.current) return;

            const threshold = window.innerHeight * 0.35;

            let activeId = null;
            for (const id of subIds) {
                const el = document.getElementById(id) || document.querySelector('.' + id);
                if (!el) continue;
                const top = el.getBoundingClientRect().top;
                if (top <= threshold) {
                    activeId = id;
                } else {
                    break;
                }
            }

            if (activeId) {
                setActiveSub((prev) => (prev !== activeId ? activeId : prev));
            }
        };

        window.addEventListener("scroll", handleScroll, { passive: true });

        handleScroll();

        return () => window.removeEventListener("scroll", handleScroll);
    }, [activePage, currentSubMenus, talkActiveTab]);

    const handleSelectPage = (pageId, sectionId = null) => {
        isManualScroll.current = true;

        // Update URL to match selected page without full reload
        if (pageId === "video-conference") {
            const isTalkSection = sectionId && (
                sectionId.startsWith("video-messenger") ||
                sectionId === "hanbirotalk"
            );
            const tab = isTalkSection ? "hanbirotalk" : "videoconference";
            setTalkActiveTab(tab);
            history.replace(tab === "hanbirotalk" ? "/hanbiro-talk" : "/video-conference");
        } else if (PAGE_ROUTES[pageId]) {
            history.replace(PAGE_ROUTES[pageId]);
        }

        if (sectionId) {
            document.body.style.overflow = "hidden";
            pendingScroll.current = sectionId;
            setActivePage(pageId);
            setActiveSub(sectionId);
            setTimeout(() => {
                isManualScroll.current = false;
            }, 800);
        } else {
            setActivePage(pageId);
            setActiveSub(null);
            window.scrollTo({ top: 0, behavior: "auto" });
            setTimeout(() => {
                isManualScroll.current = false;
            }, 600);
        }
    };

    const handleScrollTo = (sectionId) => {
        // Special case: sub-menu items của video-conference là tab IDs
        // → switch tab thay vì scroll đến element ẩn
        if (activePage === "video-conference" && (sectionId === "hanbirotalk" || sectionId === "videoconference")) {
            setTalkActiveTab(sectionId);
            setActiveSub(sectionId);
            return;
        }

        isManualScroll.current = true;
        setActiveSub(sectionId);
        const el = document.getElementById(sectionId) || document.querySelector('.' + sectionId);
        if (el) {
            const y = el.getBoundingClientRect().top + window.pageYOffset - 90;
            window.scrollTo({ top: y, behavior: "smooth" });
        }
        setTimeout(() => {
            isManualScroll.current = false;
        }, 800);
    };

    const CurrentBanner = currentPage.Banner;
    const CurrentBody = currentPage.Body; // only used for non-video-conference pages
    const isOverlay = windowWidth < 1550;

    return (
        <div className="App">
            <NavButton
                option={{
                    logo: "https://hanbiro.com/cloud/library/banner/hanbiro.svg",
                    link: "https://hanbiro.com/",
                    color: { backgroundColor: "#7061ff" },
                    itemNavClass: "item-nav nav-pur",
                    menuListProduct: "menu-list-product-item",
                    menuListVora: "vora",
                    menuListGroupware: "groupware",
                    titleTab: "mb-3",
                }}
                sidebarContent={
                    <DemoSidebar
                        pages={PAGES.map(p => p.id === "video-conference" ? { ...p, subMenus: VIDEO_CONF_SUBMENUS[talkActiveTab] || [] } : p)}
                        activePage={activePage}
                        activeSub={activeSub}
                        onSelectPage={handleSelectPage}
                        onScrollTo={handleScrollTo}
                    />
                }
            />

            {/* Layout Wrapper (Between Header and Footer) */}
            <div style={{ display: "flex", width: "100%", position: "relative" }}>

                {/* Custom Inline Sidebar */}
                <div ref={sidebarRef} className="d-none d-lg-block" style={{
                    position: "sticky",
                    top: 0,
                    alignSelf: "flex-start",
                    height: "100vh",
                    overflowY: "auto",
                    width: "320px",
                    marginLeft: showOffcanvas ? "0" : "-320px",
                    marginRight: (isOverlay && showOffcanvas) ? "-320px" : "0",
                    flexShrink: 0,
                    transition: "margin-left 0.3s ease, margin-right 0.3s ease",
                    backgroundColor: "#fff",
                    boxShadow: showOffcanvas ? "2px 0 10px rgba(0,0,0,0.05)" : "none",
                    borderRight: showOffcanvas ? "1px solid #eee" : "none",
                    zIndex: 100
                }}>
                    <div style={{ display: "flex", justifyContent: "flex-end", padding: "15px 20px 0" }}>
                        <span
                            onClick={() => setShowOffcanvas(false)}
                            style={{ cursor: "pointer", fontSize: "20px", color: "#333", fontWeight: "bold" }}
                        >
                            ✕
                        </span>
                    </div>
                    <DemoSidebar
                        pages={PAGES.map(p => p.id === "video-conference" ? { ...p, subMenus: VIDEO_CONF_SUBMENUS[talkActiveTab] || [] } : p)}
                        activePage={activePage}
                        activeSub={activeSub}
                        onSelectPage={handleSelectPage}
                        onScrollTo={handleScrollTo}
                    />
                </div>

                {/* Main Content Area */}
                <div style={{ flexGrow: 1, minWidth: 0, transition: "width 0.3s ease" }}>
                    {/* Banner Full Width */}
                    <div style={{ width: "100%" }}>
                        <CurrentBanner />
                    </div>

                    <Container
                        className="main-body"
                        fluid
                        style={{
                            maxWidth: "100%",
                            marginTop: "0px",
                            marginBottom: "0",
                            padding: "0"
                        }}
                    >
                        <Row className="mx-0">
                            {/* Right Content */}
                            <Col xs={12} className="right-content" style={{ padding: "0" }}>
                                <div style={styles.pageWrapper}>
                                    {activePage === "video-conference"
                                        ? <TalkContent onTabChange={handleTalkTabChange} activeTab={talkActiveTab} />
                                        : <CurrentBody />
                                    }
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </div>

            {/* Floating Menu Button */}
            {!showOffcanvas && (
                <div
                    className="floating-menu-btn d-none d-lg-flex align-items-center justify-content-center"
                    style={styles.floatingBtn}
                    onClick={() => setShowOffcanvas(true)}
                >
                    <AiOutlineMenu size={24} />
                </div>
            )}

            <Footer
                option={{
                    textColor: "text-color external-link text-pur-color",
                    textlinkColor: "text-color text-pur-color",
                }}
            />
        </div>
    );
}

const styles = {
    pageWrapper: {
        minHeight: "80vh",
        overflow: "hidden",
    },
    floatingBtn: {
        position: "fixed",
        bottom: "30px",
        left: "30px",
        width: "60px",
        height: "60px",
        borderRadius: "50%",
        backgroundColor: "#5a6268",
        color: "#fff",
        boxShadow: "0 4px 10px rgba(0,0,0,0.3)",
        cursor: "pointer",
        zIndex: 1050,
        transition: "transform 0.2s",
    },
    sidebar: {
        padding: "20px 10px",
        marginBottom: "20px",
    },
    sidebarItem: {
        marginBottom: "6px",
    },
    sidebarParent: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: "12px 14px",
        cursor: "pointer",
        borderRadius: "8px",
        fontWeight: "600",
        fontSize: "15px",
        transition: "all 0.2s",
        userSelect: "none",
        border: "1px solid transparent",
    },
    sidebarParentLabel: {
        flex: 1,
    },
    sidebarChevron: {
        fontSize: "14px",
        transition: "transform 0.2s",
        display: "inline-block",
    },
    sidebarSubList: {
        listStyle: "none",
        margin: "4px 0 10px 0",
        padding: "0 0 0 16px",
    },
    sidebarSubItem: {
        display: "flex",
        alignItems: "center",
        gap: "8px",
        padding: "8px 10px",
        cursor: "pointer",
        borderRadius: "6px",
        fontSize: "14px",
        color: "#666",
        transition: "all 0.15s",
    },
    sidebarArrow: {
        color: "#7061ff",
        fontWeight: "bold",
        fontSize: "16px",
        lineHeight: 1,
    },
    sidebarSubLabel: {
        flex: 1,
    },
};

export default GroupwareClone;
